<div class="page-sticky-header">
  <app-page-comp-header
    [disableTitleAnimation]="true"
    [filterDate0]="filterDate"
    [filterDate0Format]="filterDateFormat"
    [filterDate0MonthSelector]="true"
    [filterDate0Show]="showDateSelector || _showDateSelector"
    [filterDate0Title]="'Month'"
    [hideCompanyDropdownLabel]="true"
    [hideHeaderLogo]="false"
    [hierarchyFormatting]="superHierarchyEnabled"
    [initialCompanyId]="filterCompanyID"
    [label0Show]="true"
    [label0Text]="lastUpdatedText"
    [showBottomBorder]="false"
    [showCompanyDropdown]="dropdownReady"
    [showDateSelectorViaIcon]="showDateSelectorViaIcon"
    [title]="title"
    [useDashboardStyle]="false"
    (companyDropDownChange)="onCompanyDropDownChange($event)"
    (companyDropDownChange2)="onCompanyDropDownChange2($event)"
    (filterDate0Change)="onFilterDateChange($event)"
    (showDateSelectorClick)="showDateSelectorClick()"
  ></app-page-comp-header>
</div>

@if (statementDownloadEnabled) {
  <div class="row mt-3">
    <div class="col-12 d-flex justify-content-end">
      <button type="button"
              class="btn btn-soft-success"
              [disabled]="statementDownloading"
              (click)="downloadStatement()">
        @if (statementDownloading) {
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Generating Statement…
        }
        @else {
          <i class="ri-file-download-line align-bottom me-1"></i>
          Download Statement
        }
      </button>
    </div>
  </div>
}

<div class="row mt-3">
  <div class="col-12">
    <app-widget-row-usage-dashboard-stats #widgetRowStats [useCountUp]="false"></app-widget-row-usage-dashboard-stats>
  </div>
</div>

<div class="row mt-3">
  <div class="col-12">
    <app-widget-row-usage-dashboard-distribution #widgetRowDistribution
      (rightPanelMovedChange)="onDistributionRightPanelMovedChange($event)"
    ></app-widget-row-usage-dashboard-distribution>
  </div>
</div>

<div class="row mt-3">
  <div class="col-12">
    <app-widget-row-usage-dashboard-summary #widgetRowSummary
      [leadingTemplate]="summaryLeadingTemplate"
    ></app-widget-row-usage-dashboard-summary>
  </div>
</div>

<div class="row mt-3">
  <div class="col-12">
    <app-widget-row-usage-dashboard-top-sims #widgetRowTopSims
      (companyDataSaved)="onCompanyDataSaved()"
    ></app-widget-row-usage-dashboard-top-sims>
  </div>
</div>
